var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BravadoText',{staticClass:"portfolio-visibility-indicator",attrs:{"variant":"body"}},[_c('img',{staticClass:"portfolio-visibility-indicator__icon",attrs:{"src":require(`./images/${_setup.icon}.svg`),"alt":"Visibility indicator"}}),_vm._v("\n  "+_vm._s(_setup.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }